import React from 'react';
import { AutocompleteArrayInput, required, useGetList } from 'react-admin';

const AccountsArrayInput = ({ company_id }) => {
  const { data: accountsData = [] } = useGetList(
    'Account',
    {
      filter: { company_id: company_id },
      pagination: { perPage: Infinity, page: 1 },
    },
    { enabled: !!company_id },
  );

  const choices = accountsData.map(({ id, name }) => ({ id, name: `${id}: ${name}` }));
  return (
    <AutocompleteArrayInput
      key="account_ids"
      source="account_ids"
      choices={choices}
      validate={[required()]}
    />
  );
};

export default AccountsArrayInput;
